import { coreAxios } from "utilities/axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

const BASE_URL = process.env.REACT_APP_MAIN_URL

export const AddSupplier = createAsyncThunk(
  "supplier/AddSupplier",
  async (data) => {
    const response = await coreAxios.post(`${BASE_URL}/api/supplier/create/`, data)
    return response.data
  }
); 

export const UpdateSupplier = createAsyncThunk(
  "supplier/UpdateSupplier",
  async (data) => {
    const response = await coreAxios.put(`${BASE_URL}/api/supplier/update/${data.id}/`, data)
    return response.data
  }
);

export const DeleteSupplier = createAsyncThunk(
  "supplier/DeleteSupplier",
  async (id) => {
    const response = await coreAxios.delete(`${BASE_URL}/api/supplier/delete/${id}/`)
    return response.status
  }
);

export const GetSuppliers = createAsyncThunk(
  "supplier/GetSuppliers",
  async () => {
    const {data} = await coreAxios.get(`${BASE_URL}/api/supplier/list/`);
    return data
  }
);

